import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import {
  ProductListAPI,
  ProductListSearchAPI,
  getAllColorAPI,
  getBlogAPI,
  getCustomerAddressAPI,
  getPagesAPI,
  getProductDetailAPI,
  getTesimonialAPI,
  getyoutubeAPI,
  getBlogDetailsAPI,
  getTrackingOrderAPI,
  getSupportTicketAPI,
  getSupportTicketConvAPI,
  getOrderDataAPI,
  ProductListSearchQueryAPI,
  getHomeTestimonialAPI,
  getreelAPI,
  getCelebrityAPI,
  getClientdiariesAPI,
  getCelebrityHomeAPI,
  getNewHomeAPI,
  getCategoryChildAPI,
  getReviewsAPI,
  getShopByCategoryAPI,
} from "../component/APIS";




export const useProductDetails = (path) => {
  const query = useQuery({
    queryKey: ["product", path],
    queryFn: () => getProductDetailAPI(path),
    staleTime: 20000,
  });
  return query;
};

export const useColorDetails = () => {
  const query = useQuery({
    queryKey: ["allColors"],
    queryFn: () => getAllColorAPI(),
    staleTime: 20000,
  });
  return query;
};

export const useProductListSearch = (slug) => {
  const query = useQuery({
    queryKey: ["slug", slug],
    queryFn: () => ProductListSearchAPI(slug),
  });
  return query;
};


export const useSearchProductList = (searchPage,LIMIT)=>{
  const query = useInfiniteQuery({
    queryKey: ["product", searchPage],
    queryFn: ({ pageParam = 1 }) =>
    ProductListSearchQueryAPI(
        searchPage,
        LIMIT,
        pageParam
      ),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage =
        lastPage.length === LIMIT ? allPages.length + 1 : undefined;
      return nextPage;
    },
    staleTime: 2000,
    cacheTime: 0,
    keepPreviousData: true,
  });
  return query;

}

export const useProductList = (
  path,
  searchPro,
  searchCol,
  searchShip,
  searchPrice,
  searchOrderBy,
  searchRTS,
  searchMTO,
  searchNewArrivals,
  searchCategoryType,
  searchExploreBy,
  searchCategory,
  LIMIT
) => {
  const query = useInfiniteQuery({
    queryKey: ["product", path, searchPro, searchCol, searchShip, searchPrice, searchOrderBy, searchRTS, searchMTO, searchNewArrivals, searchCategoryType, searchExploreBy, searchCategory],
    queryFn: ({ pageParam = 1}) =>
      ProductListAPI(
        path,
        searchPro,
        searchCol,
        searchShip,
        searchPrice,
        searchOrderBy,
        searchRTS,
        searchMTO,
        searchNewArrivals,
        searchCategoryType,
        searchExploreBy,
        searchCategory,
        LIMIT,
        pageParam
      ),
    getNextPageParam: (lastPage, allPages) => {
      //console.log(lastPage,allPages.length)
     
      const nextPage =
        lastPage.length === LIMIT ? allPages.length+1 : undefined;
      return nextPage;
    },
    staleTime: 2000,
    cacheTime: 0,
    keepPreviousData: true,
  });
  return query;
};

export const useCustomerAddList = (id) => {
  const query = useQuery({
    queryKey: ["address", id],
    queryFn: () => getCustomerAddressAPI(id),
  });
  return query;
};

export const useTesimonialAPI = () => {
  const query = useQuery({
    queryKey: ["testimonial"],
    queryFn: () => getTesimonialAPI(),
    staleTime: 2000,
  });
  return query;
};

export const useYoutubeAPI = () => {
  const query = useQuery({
    queryKey: ["youtube"],
    queryFn: () => getyoutubeAPI(),
    staleTime: 2000,
  });
  return query;
};

export const useReelAPI = () => {
  const query = useQuery({
    queryKey: ["reel"],
    queryFn: () => getreelAPI(),
    staleTime: 2000,
  });
  return query;
};


export const useHomeTestimonialAPI = () => {
  const query = useQuery({
    queryKey: ["testimonials"],
    queryFn: () =>getHomeTestimonialAPI(),
    staleTime: 2000,
  });
  return query;
};


export const usePageAPI = (slug) => {
  const query = useQuery({
    queryKey: ["description", slug],
    queryFn: () => getPagesAPI(slug),
    staleTime: 2000,
    refetchOnWindowFocus: false,
  });
  return query;
};

export const useBlogAPI = () => {
  const query = useQuery({
    queryKey: ["blog"],
    queryFn: () => getBlogAPI(),
    staleTime: 2000,
  });
  return query;
};

export const useBlogDetailsAPI = (slug) => {
  const query = useQuery({
    queryKey: ["blog", slug],
    queryFn: () => getBlogDetailsAPI(slug),
    staleTime: 2000,
  });
  return query;
};

export const useTrackingOrderAPI = (order_id) => {
  const query = useQuery({
    queryKey: ["order", order_id],
    queryFn: () => getTrackingOrderAPI(order_id),
    staleTime: 2000,
    refetchOnWindowFocus: false,
  });
  return query;
};

export const useSupportTicketAPI = (userId) => {
  const query = useQuery({
    queryKey: ["ticket", userId],
    queryFn: () => getSupportTicketAPI(userId),
    staleTime: 2000,
  });
  return query;
};

export const useSupportTicketConvAPI = (ticketId) => {
  const query = useQuery({
    queryKey: ["ticketdata", ticketId],
    queryFn: () => getSupportTicketConvAPI(ticketId),
    staleTime: 2000,
  });
  return query;
};



export const useGetOrderDataAPI = (userId) => {
  const query = useQuery({
    queryKey: ["orders", userId],
    queryFn: () => getOrderDataAPI(userId),
    staleTime: 2000,
    refetchOnWindowFocus: false,
  });
  return query;
};

export const useCelebrityAPI = () => {
  const query = useQuery({
    queryKey: ["celebrity"],
    queryFn: () => getCelebrityAPI(),
    staleTime: 2000,
  });
  return query;
};

export const useCelebrityHomeAPI = () => {
  const query = useQuery({
    queryKey: ["celebrity"],
    queryFn: () => getCelebrityHomeAPI(),
    staleTime: 2000,
  });
  return query;
};


export const useClientdiariesAPI = () => {
  const query = useQuery({
    queryKey: ["clientdiaries"],
    queryFn: () => getClientdiariesAPI(),
    staleTime: 2000,
  });
  return query;
};

//NewBanner
export const useNewHomeAPI = () => {
  const query = useQuery({
    queryKey: ["blog"],
    queryFn: () => getNewHomeAPI(),
    staleTime: 2000,
  });
  return query;
};



export const useCategoryChildAPI = (slug) => {
  const query = useQuery({
    queryKey: ["child"],
    queryFn: () => getCategoryChildAPI(slug),
    staleTime: 2000,
  });
  return query;
};

export const useReviewsAPI = () => {
  const query = useQuery({
    queryKey: ["review"],
    queryFn: () => getReviewsAPI(),
    staleTime: 2000,
  });
  return query;
};




